import { useContext } from 'react';

import { StepFour, StepOne, StepThree, StepTwo } from '../Steps';

import { QuotationInfoContext } from '../../shared/contexts/QuotationInfo';
import { StepFourFormProvider } from '../Steps/StepFour/contexts/StepFourForm';
import { StepOneFormProvider } from '../../shared/contexts';
import { StepThreeFormProvider } from '../Steps/StepThree/contexts/StepThreeForm';
import { StepTwoFormProvider } from '../Steps/StepTwo/contexts/StepTwoForm/StepTwoFormProvider';
import { WizardDataFormProvider } from './contexts/WizardDataForm';

import { QuotationStep } from '../../shared/interfaces';
import { LoadSavedQuotation } from '../components/LoadSavedQuotation';
import { LoadRenewalQuotation } from '../components/LoadRenewalQuotation';

export const WizardCivilResponsibility = () => {
  const { currentStep, loadingSavedQuotation, loadingRenewalQuotation } =
    useContext(QuotationInfoContext);

  const getStepComponent = () => {
    switch (currentStep) {
      case QuotationStep.ONE:
        return <StepOne />;
      case QuotationStep.TWO:
        return <StepTwo />;
      case QuotationStep.THREE:
        return <StepThree />;
      case QuotationStep.FOUR:
        return <StepFour />;
      default:
        break;
    }
  };

  return (
    <StepOneFormProvider>
      <WizardDataFormProvider>
        <StepTwoFormProvider>
          <StepThreeFormProvider>
            <StepFourFormProvider>
                { loadingRenewalQuotation ? <LoadRenewalQuotation /> : loadingSavedQuotation ? <LoadSavedQuotation /> : getStepComponent() }
            </StepFourFormProvider>
          </StepThreeFormProvider>
        </StepTwoFormProvider>
      </WizardDataFormProvider>
    </StepOneFormProvider>
  );
};
